import React, { useEffect, useState } from 'react'
import "./OrderDetails.css";
import { BsFillBoxSeamFill } from 'react-icons/bs';
import { MdOutlineCall, MdOutlineEmail } from 'react-icons/md';
import roundDiamond from "../../../Assets/round-diamond-outline-removebg-preview.png";
import ProfileBanner from '../../MobileProfile/ProfileBanner';
import { LiaArrowLeftSolid } from 'react-icons/lia';

const OrderDetails = ({handleMenuClick}) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        // dispatch(setUserToken({ token: access_token }));
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])
  return (
    <>
      {isMobile?<ProfileBanner bannerName='Product Detail' leftIcon={<LiaArrowLeftSolid />} rightIcon={""} />   :""}
      <section className='orderDetail-main-sec pb-1'>
        <div>
          <div className='d-flex justify-content-center align-items-center flex-column'>
            <img className='order-details-img-tag' src={roundDiamond} alt='' />

            <p>
              <label className='fw-bold text-center d-block mb-1'> Lorem ipsum is a placeholder</label>
              <label className='text-center text-muted d-block'> Lorem ipsum is a placeholder text commonly used to  </label>
            </p>
          </div>
          <div className='d-flex gap-4 orderDetail-delivery-icon-dates'>
            <label className='d-block text-white'><BsFillBoxSeamFill /> </label>
            <label className='d-block'>
              <label className='d-block text-white'> Delivered</label>
              <label className='d-block orderDetail-day-dates'> On mon, 16 aug</label>
            </label>
          </div>


          <div className='order-detail-delivery-address-name-div'>
            <h6 className='fw-bold'> Delivery Address</h6>
            <div>
              <label className='fw-bold'> Aslam pathan</label> &nbsp; &nbsp;| &nbsp; &nbsp; <label className='fw-bold'>754126325</label>
              <p className='text-muted'>
                Lorem ipsum is a placeholder text commonly used to demonstrate
              </p>
            </div>
          </div>
          <div className='order-detail-delivery-address-name-div'>
            <h6 className='d-flex fw-bold justify-content-between mb-3'>
              <label className='d-block fw-bold'>Total Order Price</label>
              <label className='d-block fw-bold'>₹ 587000</label>
            </h6>
            <div className='order-details-get-invoce-div'>
              <label className='text-center w-100'> Get Invoice</label>
            </div>
          </div>
          <div className='order-detail-delivery-address-name-div'>
            <h6 className='fw-bold'> Updates sent to</h6>
            <div className=''>
              <div className='mb-1 text-muted'>
                <label> <MdOutlineCall /></label>   &nbsp;7845152635
              </div>
              <div className='mb-1 text-muted'>
                <label> <MdOutlineEmail /></label>   &nbsp;sejalgems@gmail.com
              </div>
            </div>
          </div>
          <div className='order-detail-delivery-address-name-div'>
            <div className=''>
              <div className='mb-1 text-muted'>
                Order ID # 1059958 06408134456503
              </div>

            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default OrderDetails